function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.32,
  fill: "#fff",
  d: "M14.26 17.303L9.57 20.16v5.742l4.69-2.856z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.85328 .52145 -.85328 .52145 9.57 14.437)",
  fill: "url(#sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__int0_icon_linear)",
  d: "M0 0h5.496v5.496H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.32,
  fill: "#fff",
  d: "M28.852 8.966l-4.69 2.856v5.742l4.69-2.856z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.85328 .52145 -.85328 .52145 24.162 6.1)",
  fill: "url(#sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__int1_icon_linear)",
  d: "M0 0h5.496v5.496H0z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.32,
  fill: "#fff",
  d: "M21.556 13.134l-4.69 2.857v5.742l4.69-2.857z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.85328 .52145 -.85328 .52145 16.866 10.269)",
  fill: "url(#sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__int2_icon_linear)",
  d: "M0 0h5.496v5.496H0z"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__int0_icon_linear",
  x1: 6.357,
  y1: 0.861,
  x2: 1.101,
  y2: 7.649,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__int1_icon_linear",
  x1: 6.357,
  y1: 0.861,
  x2: 1.101,
  y2: 7.649,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__sp-sources_svg__int2_icon_linear",
  x1: 6.357,
  y1: 0.861,
  x2: 1.101,
  y2: 7.649,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})));

var SvgSpSources = function SvgSpSources(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 5 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpSources, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sp-sources.11b65303.svg";
export { ForwardRef as ReactComponent };